/* eslint-disable import/no-cycle */
import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import { AuthProvider } from './store/AuthContext';
import { AppProvider } from './store/AppContext';
import { APIErrorProvider } from './store/APIErrorContext';
import { APILoadingProvider } from './store/APILoadingContext';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="277223809512-8cod3gcaq35b0q7u0kvin1lgukub6566.apps.googleusercontent.com">
      <AuthProvider>
        <APILoadingProvider>
          <APIErrorProvider>
            <AppProvider>
              <App />
            </AppProvider>
          </APIErrorProvider>
        </APILoadingProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
/* eslint-enable import/no-cycle */
